export const hasNoEmptyValues = (tuple) => {
  return tuple.filter(Boolean).length
}
